export default "__VITE_ASSET__a55a004e__"